import React from 'react';
import { Checkbox, Typography, Collapse, withStyles } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import CloseImage from '../../assets/ic_close.png'; 
import api from '../api';
import { format } from 'date-fns';
import CustomDate from '../components/customDate';
import CustomTextField from '../components/customTextField';

const CustomCheckbox = withStyles({
    root: {
        color: '#2a9c6c',
        '&$checked': {
            color: '#2a9c6c',
        },
        padding: 5
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default function EditRole(props) {

    const [validTo, setValidTo] = React.useState(new Date());
    const [validFrom, setValidFrom] = React.useState(new Date());
    const [roleName, setRoleName] = React.useState("");
    const [id, setID] = React.useState("");
    const [helperRole, setHelperRole] = React.useState("");
    const [status, setStatus] = React.useState("");
    const [errorRoleName, setErrorRole] = React.useState(false);
    let [application, setApplication] = React.useState([])
    let [privileges, setPrivileges] = React.useState([])

    React.useEffect(() => {
        getDetail()
    }, [])

    const getMenu = () => {
        api.create().getListMenu().then((response) => {
            if (response.data) {
                if (response.data.status === true) {
                    let app = null
                    response.data.data.map((item) => {
                        if (item.menu_name === "Application") {
                            app = parseChildren(item.sub_menu)
                            return app
                        }
                    })
                    setApplication(app)
                } else {

                }
            } else {
            }
        })
    }

    const getDetail = () => {
        api.create().getDetailRole(props.detail[3]).then((response) => {
            console.log(response.data.data);
            if (response.data) {
                if (response.data.status === true) {
                    setID(response.data.data.id)
                    setRoleName(response.data.data.name)
                    setPrivileges(response.data.data.menus)
                    setValidFrom(new Date(response.data.data.valid_from))
                    setValidTo(new Date(response.data.data.valid_to))
                    setStatus(response.data.data.is_active === true ? "Active" : "Inactive")
                    forceUpdate()
                    getMenu()
                } else {

                }
            } else {
            }
        })
    }

    const parseChildren = (val) => {
        let data = Object.assign([], val)
        // console.log(data);
        data = data.sort((a, b) => a.menu_id - b.menu_id).map((i) => {
            return {
                menu_id: i.menu_id,
                label: i.menu_name,
                sub_menu: parseChildren(i.sub_menu),
                collapse: false,
                reference: i.reference
            }
        })
        return data
    }

    const updateRole = () => {
        let menu = []
        privileges.map(item => {
            menu.push({
                id: item.menu_id,
                button_id: item.button_id
            })
        })
        console.log(validFrom);
        let payload = {
            "role_id": id,
            "role_name": roleName,
            "valid_from": format(validFrom, 'yyyy-MM-dd'),
            "valid_to": format(validTo, 'yyyy-MM-dd'),
            "menus": menu
        }
        props.updateRole(payload)
        props.onClose()
    }


    const handleItemChecked = (item) => {
        let indexID = privileges.findIndex((val) => val.menu_id === item.menu_id)
        return indexID === -1 ? false : true
    }

    const handleItemClick = (item) => {
        let indexID = privileges.findIndex((val) => val.menu_id === item.menu_id)
        console.log(indexID);
        if (indexID === -1) {
            privileges.push({
                menu_id: item.menu_id,
                button_id: [1, 2, 3, 4]
            })
            if (item.sub_menu.length > 0) {
                item.sub_menu.map((items, indexs) => {
                    let indexIDs = privileges.findIndex((val) => val.menu_id === items.menu_id)
                    if (indexIDs === -1) {
                        privileges.push({
                            menu_id: items.menu_id,
                            button_id: [1, 2, 3, 4]
                        })
                    }
                })
            }
            if (item.reference !== null && item.reference !== 22 && item.reference !== 1) {
                let indexIDapp = application.findIndex((val) => val.menu_id === item.reference)
                let indexIDref = privileges.findIndex((val) => val.menu_id === item.reference)
                let indexIDs = indexIDapp === -1 ? null : indexIDapp
                let total = 0
                let array = indexIDapp === -1 ? null : application

                if (array !== null) {
                    array[indexIDs].sub_menu.map((items, indexs) => {
                        let indexIDsub = privileges.findIndex((val) => val.menu_id === items.menu_id)
                        if (indexIDsub !== -1) {
                            total += 1
                        }
                    })
                }
                if (indexIDref === -1) {
                    privileges.push({
                        menu_id: item.reference,
                        button_id: [1, 2, 3, 4]
                    })
                } else {
                    if (total < 1) {
                        privileges.splice(indexIDref, 1)
                    }
                }
            }
        } else {
            privileges.splice(indexID, 1)
            if (item.sub_menu.length > 0) {
                item.sub_menu.map((items, indexs) => {
                    let indexIDs = privileges.findIndex((val) => val.menu_id === items.menu_id)
                    if (indexIDs > -1) {
                        privileges.splice(indexIDs, 1)
                    }
                })
            }
            if (item.reference !== null && item.reference !== 22 && item.reference !== 1) {
                let indexIDapp = application.findIndex((val) => val.menu_id === item.reference)
                let indexIDref = privileges.findIndex((val) => val.menu_id === item.reference)
                let indexIDs = indexIDapp === -1 ? null : indexIDapp
                let total = 0
                let array = indexIDapp === -1 ? null : application

                if (array !== null) {
                    array[indexIDs].sub_menu.map((items, indexs) => {
                        let indexIDsub = privileges.findIndex((val) => val.menu_id === items.menu_id)
                        if (indexIDsub !== -1) {
                            total += 1
                        }
                    })
                }

                if (indexIDref === -1) {
                    privileges.push({
                        menu_id: item.reference,
                        button_id: [1, 2, 3, 4]
                    })
                } else {
                    if (total < 1) {
                        privileges.splice(indexIDref, 1)
                    }
                }
            }
        }
        setPrivileges(privileges)
        console.log(privileges);
        forceUpdate()
    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    const handleSubItemChecked = (item, index) => {
        let indexID = privileges.findIndex((val) => val.menu_id === item.menu_id)
        let value = false
        if (indexID === -1) {
            value = false
        } else {
            let indexButtonID = privileges[indexID].button_id.findIndex((val) => val === index)
            if (indexButtonID === -1) {
                value = false
            } else {
                value = true
            }
        }
        return indexID === -1 ? value : value
    }

    const handleSubItemClick = (item, index) => {
        let indexID = privileges.findIndex((val) => val.menu_id === item.menu_id)
        let indexButtonID = privileges[indexID].button_id.findIndex((val) => val === index)
        let button_id = privileges[indexID].button_id

        if (indexButtonID === -1) {
            button_id.push(index)
            if (item.sub_menu.length > 0) {
                item.sub_menu.map((items, indexs) => {
                    let subIndexID = privileges.findIndex((val) => val.menu_id === items.menu_id)
                    if (subIndexID === -1) {
                        // console.log('masuk pa eko', subIndexID)
                        privileges.push({
                            menu_id: items.menu_id,
                            button_id: [index]
                        })
                    } else {
                        let subIndexButtonID = privileges[subIndexID].button_id.findIndex((val) => val === index)
                        let subButton_id = privileges[subIndexID].button_id
                        if (subIndexButtonID === -1) {
                            subButton_id.push(index)
                        }
                    }
                })
            }
            if (item.reference !== null && item.reference !== 22 && item.reference !== 1) {
                let refIndexID = privileges.findIndex((val) => val.menu_id === item.reference)
                if (refIndexID !== -1) {
                    let refIndexButtonID = privileges[refIndexID].button_id.findIndex((val) => val === index)
                    let refButton_id = privileges[refIndexID].button_id
                    if (refIndexButtonID === -1) {
                        refButton_id.push(index)
                    }
                    privileges[refIndexID].button_id = refButton_id
                }
            }
        } else {
            button_id.splice(indexButtonID, 1)
            if (item.sub_menu.length > 0) {
                item.sub_menu.map((items, indexs) => {
                    let subIndexID = privileges.findIndex((val) => val.menu_id === items.menu_id)
                    if (subIndexID !== -1) {
                        let subIndexButtonID = privileges[subIndexID].button_id.findIndex((val) => val === index)
                        let subButton_id = privileges[subIndexID].button_id
                        if (subIndexButtonID !== -1) {
                            subButton_id.splice(subIndexButtonID, 1)
                            privileges[subIndexID].button_id = subButton_id
                            if (privileges[subIndexID].button_id.length < 1) {
                                privileges.splice(subIndexID, 1)
                            }
                        }
                    }
                })
            }
            if (item.reference !== null && item.reference !== 22 && item.reference !== 1) {
                let refIndexID = privileges.findIndex((val) => val.menu_id === item.reference)
                if (refIndexID !== -1) {
                    let refIndexButtonID = privileges[refIndexID].button_id.findIndex((val) => val === index)
                    let refButton_id = privileges[refIndexID].button_id
                    let indexIDapp = application.findIndex((val) => val.menu_id === item.reference)
                    let indexIDs = indexIDapp === -1 ? null : indexIDapp
                    let array = indexIDapp === -1 ? null : application
                    let splicer = 0
                    array[indexIDs].sub_menu.map((refItem, refIndex) => {
                        let subIndexID = privileges.findIndex((val) => val.menu_id === refItem.menu_id)
                        if (subIndexID !== -1) {
                            let subIndexButtonID = privileges[subIndexID].button_id.findIndex((val) => val === index)
                            if (subIndexButtonID !== -1) {
                                splicer += 1
                            }
                        }
                    })
                    if (refIndexButtonID !== -1 && splicer < 1) {
                        refButton_id.splice(refIndexButtonID, 1)
                    }
                    privileges[refIndexID].button_id = refButton_id
                }
            }
        }
        privileges[indexID].button_id = button_id.sort((a, b) => a - b)
        if (button_id.length === 0) {
            privileges.splice(indexID, 1)
        }
        setPrivileges(privileges.sort((a, b) => a.menu_id - b.menu_id))
        forceUpdate()
    }

    const handleCollapse = (item) => {
        let arr = application
        let index = arr.findIndex((val) => val.label === item.label)
        arr[index].collapse = !arr[index].collapse
        setApplication(arr)
        forceUpdate()
    }

    return (
        <div className="App app-popup-show">
            <div className="popup-content-middle background-white" style={{ borderRadius: 8 }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Role Baru</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20 }}>
                    <div className="column-1">
                        <div className="margin-bottom-20px">
                            <CustomTextField
                                label="ID"
                                variant="filled"
                                disabled={true}
                                value={id}
                            />
                        </div>
                    </div>

                    <div className="column-2">
                        <div className="margin-bottom-20px" style={{marginTop: 8}}>
                            <CustomTextField
                                required={true}
                                label={"User Role"}
                                value={roleName}
                                error={errorRoleName}
                                helperText={helperRole}
                                onChange={(val) => {
                                    setErrorRole(false)
                                    setHelperRole("")
                                    setRoleName(val)
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ paddingLeft: 20, paddingRight: 20 }}>
                    <div className="column-1">
                        <CustomDate
                            value={validFrom}
                            label={"Valid From"}
                            setValue={(date) => {
                                setValidFrom(date)
                            }}
                        />
                    </div>

                    <div className="column-2">
                        <CustomDate
                            value={validTo}
                            label={"Valid To"}
                            minDate={validFrom}
                            setValue={(date) => {
                                setValidTo(date)
                            }}
                        />
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ paddingLeft: 20, paddingRight: 20, marginTop: 20, marginBottom: 20 }}>
                    <div className="column-1">
                        <div className="margin-top-20px">
                            <CustomTextField
                                label="Status"
                                variant="filled"
                                disabled={true}
                                value={status}
                            />
                        </div>
                    </div>
                </div>

                <div style={{ paddingLeft: 20, paddingRight: 20, marginBottom: 20 }}>
                    <h5>Access Rights</h5>
                    <div className="grid grid-2x grid-mobile-none gap-15px padding-top-5px padding-bottom-5px padding-left-10px padding-right-10px " style={{ backgroundColor: '#4b4b4b' }}>
                        <div className="column-1">
                            <Typography style={{ fontSize: 12, color: 'white' }}>Authorization Module</Typography>
                        </div>
                        <div className="column-2 grid grid-4x content-center grid-mobile-none gap-15px">
                            <div className="column-1">
                                <Typography style={{ fontSize: 12, color: 'white' }}>View</Typography>
                            </div>
                            <div className="column-2">
                                <Typography style={{ fontSize: 12, color: 'white' }}>Create</Typography>
                            </div>
                            <div className="column 3">
                                <Typography style={{ fontSize: 12, color: 'white' }}>Edit</Typography>
                            </div>
                            <div className="column 4">
                                <Typography style={{ fontSize: 12, color: 'white' }}>Delete</Typography>
                            </div>
                        </div>
                    </div>

                    <div style={{ height: '25vh', overflow: 'scroll' }}>
                        {application.map((item, index) => {
                            return (
                                <div>
                                    <div className="grid grid-2x grid-mobile-none gap-15px padding-left-10px padding-right-10px">
                                        <div className="column-1" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', paddingLeft: 8, marginLeft: 10 }}>
                                            {item.sub_menu.length > 0 && <span onClick={() => handleCollapse(item)} style={{ marginRight: 2, marginLeft: -22 }}>
                                                {item.collapse ? <RemoveIcon color={'action'} fontSize={'small'} /> : <AddIcon color={'action'} fontSize={'small'} />}
                                            </span>}
                                            <span>
                                                <CustomCheckbox
                                                    checked={handleItemChecked(item)}
                                                    onChange={() => handleItemClick(item)}
                                                />
                                            </span>
                                            <Typography style={{ fontSize: 12, marginLeft: 5 }}>{item.label}</Typography>
                                        </div>
                                        <div className="column-2 grid grid-4x content-center grid-mobile-none gap-15px margin-left-10px">
                                            <div className="column-1">
                                                <CustomCheckbox
                                                    disabled={!handleItemChecked(item)}
                                                    checked={handleSubItemChecked(item, 1)}
                                                    onChange={() => handleSubItemClick(item, 1)}
                                                />
                                            </div>
                                            <div className="column-2">
                                                <CustomCheckbox
                                                    // disabled
                                                    disabled={!handleItemChecked(item)}
                                                    checked={handleSubItemChecked(item, 2)}
                                                    onChange={() => handleSubItemClick(item, 2)}
                                                />
                                            </div>
                                            <div className="column 3">
                                                <CustomCheckbox
                                                    // disabled
                                                    disabled={!handleItemChecked(item)}
                                                    checked={handleSubItemChecked(item, 3)}
                                                    onChange={() => handleSubItemClick(item, 3)}
                                                />
                                            </div>
                                            <div className="column 4">
                                                <CustomCheckbox
                                                    // disabled
                                                    disabled={!handleItemChecked(item)}
                                                    checked={handleSubItemChecked(item, 4)}
                                                    onChange={() => handleSubItemClick(item, 4)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {item.sub_menu.length > 0 && item.sub_menu.map((items, indexs) => {
                                        return (
                                            <Collapse in={item.collapse} timeout="auto" unmountOnExit>
                                                <div className="grid grid-2x grid-mobile-none gap-15px padding-left-10px padding-right-10px">
                                                    <div className="column-1" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', paddingLeft: 50 }}>
                                                        <CustomCheckbox
                                                            checked={handleItemChecked(items)}
                                                            onChange={() => handleItemClick(items)}
                                                        />
                                                        <Typography style={{ fontSize: 12, maxWidth: '100%', marginLeft: 5 }}>{items.label}</Typography>
                                                    </div>
                                                    <div className="column-2 grid grid-4x content-center grid-mobile-none gap-15px margin-left-10px">
                                                        <div className="column-1">
                                                            <CustomCheckbox
                                                                disabled={!handleItemChecked(items)}
                                                                checked={handleSubItemChecked(items, 1)}
                                                                onChange={() => handleSubItemClick(items, 1)}
                                                            />
                                                        </div>
                                                        <div className="column-2">
                                                            <CustomCheckbox
                                                                disabled={!handleItemChecked(items)}
                                                                checked={handleSubItemChecked(items, 2)}
                                                                onChange={() => handleSubItemClick(items, 2)}
                                                            />
                                                        </div>
                                                        <div className="column 3">
                                                            <CustomCheckbox
                                                                disabled={!handleItemChecked(items)}
                                                                checked={handleSubItemChecked(items, 3)}
                                                                onChange={() => handleSubItemClick(items, 3)}
                                                            />
                                                        </div>
                                                        <div className="column 4">
                                                            <CustomCheckbox
                                                                disabled={!handleItemChecked(items)}
                                                                checked={handleSubItemChecked(items, 4)}
                                                                onChange={() => handleSubItemClick(items, 4)}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </Collapse>
                                        )
                                    })}
                                </div>
                            )
                        })}
                    </div>
                </div>


                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div
                            onClick={() => props.onClose()}
                            style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div
                            onClick={() => updateRole()}
                            style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}